<div class="app-table-container">
  <div class="app-table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort
           [matSortActive]="sort[0]" [matSortDirection]="sort[1]"
           [matSortDisableClear]="true">

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row" class="secondary">#{{row.id}}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Тип</th>
        <td mat-cell *matCellDef="let row">{{row.type == 'COMMON' ? 'Общий' : row.type == 'TEST' ? 'Тестовый' : row.type == 'POLL' ? 'Опрос' : row.type}}</td>
      </ng-container>

      <ng-container matColumnDef="name" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Название</th>
        <td mat-cell *matCellDef="let row">
          <a [routerLink]="['/tests/', row.id]">{{row.name}}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="updateDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Обновлён</th>
        <td mat-cell *matCellDef="let row">
          <app-time-event [value]="row.updateDate"></app-time-event>
        </td>
      </ng-container>

      <ng-container matColumnDef="isActivated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >Статус</th>
        <td mat-cell *matCellDef="let row">{{row.activateDate ? 'Активен' : 'Не активен'}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>

    <div class="spinner-container" *ngIf="dataSource.loading$|async">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <mat-paginator [length]="dataSource.totalElements$|async"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="pageSizeOptions"
                 [pageIndex]="pageNumber"></mat-paginator>

</div>
